import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router";
import Tab from "./Tab";

interface Link {
  to: string;
  text: string;
}

interface Props {
  tabs: Link[];
}

const NavTabs = ({ tabs }: Props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const selectedIndex = useMemo(
    () => tabs.findIndex((t) => location.pathname.includes(`/${t.to}`)),
    [location.pathname],
  );

  return (
    <Tab.Group
      selectedIndex={selectedIndex}
      onChange={(i) => {
        if (!tabs[i]) return;
        navigate(tabs[i].to);
      }}
    >
      <Tab.List>
        {tabs.map((t) => (
          <Tab key={t.to} title={t.text}>
            {t.text}
          </Tab>
        ))}
      </Tab.List>
    </Tab.Group>
  );
};

export default NavTabs;
